import styled from 'styled-components';

const StyledButtonContainer = styled.div`
	display: flex;
	position: relative;
	align-self: stretch;
	align-items: center;
	justify-content: center;
	background: var(--color-global-grey200);
	width: 4.4rem;
`;

const StyledButton = styled.div`
	display: none;

	@media not all and (pointer: coarse) {
		display: flex;
		align-items: center;
		position: absolute;
		top: 0;
		height: 100%;
	}
`;

const StyledPreviousButton = styled(StyledButton).attrs({
	className: 'fuse-tabs__previous-button',
	'data-testid': 'fuse-tabs-previous-button-test-id',
})`
	left: 0;

	&.hidden {
		display: none;
	}
`;

const StyledNextButton = styled(StyledButton).attrs({
	className: 'fuse-tabs__next-button',
	'data-testid': 'fuse-tabs-next-button-test-id',
})`
	right: 0;

	&.hidden {
		display: none;
	}
`;

export { StyledButtonContainer, StyledPreviousButton, StyledNextButton };
